import React from "react";
import Card from "../../../Components/share/cards/Card";
import IconButton from "../../share/buttons/IconButton";
import { ReactComponent as Edit } from "../../../Assets/Image/svg/edit.svg";

function SurveyTable(props) {
    return (
        <div>
            <Card className="  SupportTicketTable-header SupportTicketTable-card SupportTicketTable-card-treecol mt-[2rem]">
                <div className="text-[#212121E5] font-bold  leading-[1.8rem] text-[1.7rem]  text-right">
                    نوع نظرسنجی
                </div>
                <div className="text-[#212121E5] font-bold  leading-[1.8rem] text-[1.7rem] text-right">
                    تعداد سوالات
                </div>
                <div className="text-[#212121E5] font-bold  leading-[1.8rem] text-[1.7rem] text-right">
                    زمان برگزاری
                </div>
                <div></div>
            </Card>
            {props.list?.map((i, id) => (
                <Card
                    key={i?.id}
                    className="SupportTicketTable-card SupportTicketTable-card-treecol SupportTicketTable-body  my-4 starttable"
                >
                    <div className=" cursor-pointer text-right flex items-center justify-start starttable">
                        {i?.question_type === "Test"
                            ? "چهار گزینه‌ای"
                            : i?.question_type === "Descriptive"
                            ? "تشریحی"
                            : "فایل"}
                    </div>
                    <div className=" text-right">{i?.date}</div>
                    <div className=" text-right">{i?.info}</div>

                    <div>
                        {i.test ? (
                            <IconButton data-tip="ویرایش" className="">
                                <Edit />
                            </IconButton>
                        ) : (
                            <div className=" text-[#9C5FA4] font-normal text-[1.4rem] leading-[2.4rem] cursor-pointer">
                                مشاهده نتایج
                            </div>
                        )}
                    </div>
                </Card>
            ))}
        </div>
    );
}

export default SurveyTable;
